var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalancesheetActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Balance_O") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large_review",
    transform: "translate(-27.000000, -501.000000)",
    stroke: "#92CDE7",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Balance_O",
    transform: "translate(27.000000, 501.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,17.25 L11.25,20.25",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,20.25 L8.25,23.25",
    id: "Stroke-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,20.25 L14.25,23.25",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25,17.25 L2.25,17.25 C1.422,17.25 0.75,16.579 0.75,15.75 L0.75,2.25 C0.75,1.422 1.422,0.75 2.25,0.75 L20.25,0.75 C21.078,0.75 21.75,1.422 21.75,2.25 L21.75,15.75 C21.75,16.579 21.078,17.25 20.25,17.25 Z",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    points: "3.75 9.7499 6.75 9.7499 8.25 6.7499 11.25 11.9999 13.5 8.2499 15.75 9.7499 18.75 5.9999"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancesheetActive);
export default __webpack_public_path__ + "static/media/balancesheet-active.e2120881aae72e59ef60f04c10806622.svg";
export { ForwardRef as ReactComponent };